webpackJsonp([156361354810763],{

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookBindActions = __webpack_require__(62);
	
	var _LoreHookBindActions2 = _interopRequireDefault(_LoreHookBindActions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookBindActions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Dependencies'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook depends on:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'lore-hook-actions'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'lore-hook-redux'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Because this hook generates actions, it needs the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'models'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'collections'
	      ),
	      ' to exist before it runs.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'actions'
	      ),
	      ' dependency comes from the fact that the role of this hook is to bind the actions to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dispatch()'
	      ),
	      ' method of the Redux store.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'redux'
	      ),
	      ' dependency comes from the fact that it needs the Redux store to exist before it can get the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dispatch()'
	      ),
	      ' method.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-bind-actions-dependencies-js-1c7d645ffa70de464af2.js